import React, { Component, Fragment } from 'react';
import { PATHS, DETAIL_ACTIONS, FEATURE_FLAGS } from "../../../../../constants/Define";
import * as HMS from "../../../common/component/Index";
import * as Func from '../../../../../helpers/functions';
import TranslateButton from '../../../common/component/TranslateButton';
import { isEqual, get, cloneDeep, find } from 'lodash';
import Wrapper from './../../../common/component/Wrapper';
import Input from "../../../common/component/Input";
import { checkUndefine } from "../../../../../helpers/functions";
import VinWonderTicket from '../../../../../models/VinWonderTicket';
import VinWonderTicketItemList from '../VinWonderTicketItem/VinWonderTicketItemList';
import './VinWonderTicketDetail.less';

const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    validation: {},
    isGetItem: false
};

class VinWonderTicketDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            isSubmit: false,
            vinWonderTicket: this.props.vinWonderTicketState.detail.vinWonderTicket,
        }
    }

    componentDidMount() {
        this.initDetail();
        this.props.onGetUpdate({ id: this.props.match.params.vin_wonder_id });
    }
    

    initDetail() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            this.props.getVinWonderTicketDetail(id);
        }
    }

    componentWillUnmount() {
        this.props.setVinWonderTicketDetail(new VinWonderTicket())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.vinWonderTicketState.detail.vinWonderTicket && !isEqual(nextProps.vinWonderTicketState.detail.vinWonderTicket, this.props.vinWonderTicketState.detail.vinWonderTicket)) {
            this.setState({ vinWonderTicket: nextProps.vinWonderTicketState.detail.vinWonderTicket, action: nextProps.vinWonderTicketState.detail.vinWonderTicket.id ? 'UPDATE' : this.state.action });
        }
    }

    render() {
        const { t, match } =  this.props;
        const { action, isSubmit, validation, isGetItem, vinWonderTicket } = this.state;
        const isUpdateAction = action === DETAIL_ACTIONS.UPDATE;

        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent className="vin-wonder-ticket-detail-page">
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'vinWonderTickets'}
                            onClickBack={this.onClickBack}
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.vinWonderTickets.title')}`))
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.vinWonderTickets.title')}`))
                            }
                            componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                                <TranslateButton
                                    languages={vinWonderTicket.translations}
                                    current={vinWonderTicket.languageCode}
                                    validation={validation.languageCode}
                                    onChange={this.onShowTranslate}
                                    onClear={this.onExitTranslate}
                                    defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                    onSelectDefault={language => this.onChange('languageCode', language.code)}
                                    onRemove={this.onRemoveTranslate} />
                            }
                        />
                        <HMS.FormActionComponent
                            disableButtonBack
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                            titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                            onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                            submitButtonRight={true}
                            statusActiveName={`isActive`}
                        >
                            <Wrapper className='col-md-12 basic-section'>
                                <HMS.FormWrapperItem>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            isValidation={true}
                                            dataValidation={vinWonderTicket.name}
                                            validation={validation.name}
                                            labelTitle={t(`item.vinWonderTickets.name`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                className={`form-control`}
                                                name={`name`} onChange={(e) => this.onChange('name', e.target.value)}
                                                value={Func.checkUndefine(vinWonderTicket.name)} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    { action === DETAIL_ACTIONS.UPDATE &&
                                        <Wrapper className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                dataValidation={vinWonderTicket.ticketCode}
                                                validation={validation.ticketCode}
                                                labelTitle={t(`item.vinWonderTickets.ticketCode`)}
                                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    disabled={isUpdateAction}
                                                    name={`name`} onChange={(e) => this.onChange('ticketCode', e.target.value)}
                                                    value={checkUndefine(vinWonderTicket.ticketCode)} />
                                            </HMS.FormWrapperInputComponent>
                                        </Wrapper>
                                    }
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={t(`item.vinWonderTickets.shortDescriptions`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                className={`form-control`}
                                                name={`name`} onChange={(e) => this.onChange('shortDescriptions', e.target.value)}
                                                value={checkUndefine(vinWonderTicket.shortDescriptions)} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={t(`item.vinWonderTickets.descriptions`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                className={`form-control`}
                                                name={`name`} onChange={(e) => this.onChange('descriptions', e.target.value)}
                                                value={checkUndefine(vinWonderTicket.descriptions)} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-12">
                                        <HMS.CheckboxComponent
                                            name='isAvailable'
                                            className={`mr-4`}
                                            disabled={action === DETAIL_ACTIONS.TRANSLATE}
                                            onChange={this.onChangeChecked}
                                            checked={vinWonderTicket.isAvailable}>{t(`item.vinWonderTickets.isAvailable`)}
                                        </HMS.CheckboxComponent>
                                    </Wrapper>
                                </HMS.FormWrapperItem>
                            </Wrapper>
                        </HMS.FormActionComponent>
                        {
                            action === DETAIL_ACTIONS.UPDATE &&
                            <VinWonderTicketItemList 
                                vinWonderTicketId={match.params.id}
                                vinWonderTicketItems={vinWonderTicket.vinWonderTicketItems}
                            />
                        }
                        
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        )
    }

    onClickBack = () => {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.vin_wonder_id) {
            const path = Func.getPathWithParams(PATHS.VIN_WONDER_TICKET.LIST.path, { vin_wonder_id: match.params.vin_wonder_id })
            this.props.history.push(path);
        }
    }

    onSaveTranslate = () => {
        const { vinWonderTicket } = this.state;
        const translateFunction = vinWonderTicket.translate.id ? this.props.updateVinWonderTicketTranslate : this.props.createVinWonderTicketTranslate;
        translateFunction(vinWonderTicket, vinWonderTicket.languageCode);
        this.onExitTranslate();
    }

    onChange = (fieldName, value) => {
        const vinWonderTicket = this.state.vinWonderTicket;
        const keyString = value;
        vinWonderTicket[fieldName] = keyString.trimLeft();
        this.setState({ vinWonderTicket });
    };

    onChangeChecked = (e, tag) => {
        const vinWonderTicket = this.state.vinWonderTicket;
        let params = Func.getValueForm(e);
        vinWonderTicket[params.name] = typeof params.value === 'string' ? params.value.trimLeft() : params.value;
        this.setState({ vinWonderTicket });
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { match } = this.props;
        const { vinWonderTicket, action } = this.state;
        vinWonderTicket.vinWonderId = match.params.vin_wonder_id;
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createVinWonderTicketDetail(vinWonderTicket)
            } else {
                this.props.updateVinWonderTicketDetail({ vinWonderTicket, props: this.props })
            }
        }
    }

    convertStringKey = (value) => {
        const convertedString = Func.vietnameseStringToUnicode(value)
        return convertedString.replace(" ", "_", convertedString.replace("&*#39;","",convertedString));
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.vinWonderTickets.name`))
            },
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        let valueValidate = {

        };
        const result = Func.multipleValidate(this.state.vinWonderTicket, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    onShowTranslate = (language) => {
        const { vinWonderTicket } = this.state;
        vinWonderTicket.setTranslate(language.code);
        vinWonderTicket.setData();
        this.setState({ vinWonderTicket, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const vinWonderTicket = cloneDeep(this.state.vinWonderTicket);
        const action = DETAIL_ACTIONS[vinWonderTicket.id ? 'UPDATE' : 'CREATE'];
        vinWonderTicket.setTranslate(undefined, true);
        vinWonderTicket.setData();
        this.setState({ vinWonderTicket, action });
    }

    onSaveTranslate = () => {
        const { vinWonderTicket } = this.state;
        const translateFunction = vinWonderTicket.translate.id ? this.props.updateVinWonderTicketTranslate : this.props.createVinWonderTicketTranslate;
        translateFunction(vinWonderTicket, vinWonderTicket.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { vinWonderTicket } = this.state;
        vinWonderTicket.setTranslate(language.code);
        this.props.deleteVinWonderTicketTranslate(vinWonderTicket, { id: vinWonderTicket.id });
    }
}

export default VinWonderTicketDetail;
